export const CounterQcFieldName = 'counterQcFieldComponent';
